/* Refillia: ricerca a tutto schermo al posto della finestra di Horizon */
(function () {
  var box = document.getElementById('rr');
  if (!box || box._rr) return;
  box._rr = true;
  var fin = box.querySelector('.rr__fin');
  var inp = box.querySelector('[data-rr-input]');
  var svuota = box.querySelector('[data-rr-svuota]');
  var corpo = box.querySelector('[data-rr-corpo]');
  var pieno = box.querySelector('[data-rr-pieno]');
  var vuoto = box.querySelector('[data-rr-vuoto]');
  var anteprima = window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main' ? Shopify.theme.id : null;
  function url(u) { return anteprima ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + anteprima : u; }
  var URL_SUG = box.dataset.sug;
  var URL_CORPO = url(box.dataset.corpo);
  var SEGNA = box.dataset.segnaposto, SEGNA_EQ = box.dataset.segnapostoEq;
  var corpoPronto = !box.querySelector('[data-rr-attesa]'), inArrivo = null;
  var timer = null, ctrl = null, ultimo = '', cache = {}, prima = null;

  function stili() {
    [box.dataset.carte, box.dataset.coll].forEach(function (href) {
      if (!href) return;
      var nome = href.split('/').pop().split('?')[0];
      if (document.querySelector('link[href*="' + nome + '"]')) return;
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      document.head.appendChild(l);
    });
  }

  function caricaCorpo() {
    if (corpoPronto) return Promise.resolve();
    if (inArrivo) return inArrivo;
    inArrivo = fetch(URL_CORPO).then(function (r) { return r.json(); }).then(function (j) {
      var tmp = document.createElement('div');
      tmp.innerHTML = j['rf-ricerca'] || '';
      var nuovo = tmp.querySelector('[data-rr-vuoto]');
      if (nuovo && vuoto) {
        nuovo.hidden = vuoto.hidden;
        vuoto.replaceWith(nuovo);
        vuoto = nuovo;
        corpoPronto = true;
      }
      box.classList.remove('is-carica');
    }).catch(function () { inArrivo = null; box.classList.remove('is-carica'); });
    return inArrivo;
  }
  window.addEventListener('load', function () {
    setTimeout(function () { (window.requestIdleCallback || setTimeout)(caricaCorpo, { timeout: 5000 }); }, 2500);
  });

  var APRI = 'search-button button, .rf-cerca, .rf-trova, [data-rf-apri-ricerca]';
  ['pointerover', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target.closest && e.target.closest(APRI)) { stili(); caricaCorpo(); }
    }, { passive: true });
  });

  function modoEquivalente(si) {
    inp.placeholder = si ? SEGNA_EQ : SEGNA;
  }

  function apri(opz) {
    opz = opz || {};
    modoEquivalente(!!opz.equivalente);
    if (box.classList.contains('is-aperto')) { inp.focus(); return; }
    prima = document.activeElement;
    stili();
    if (!corpoPronto) { box.classList.add('is-carica'); caricaCorpo(); }
    box.hidden = false;
    document.documentElement.classList.add('rr-bloccato');
    void fin.offsetWidth;
    box.classList.add('is-aperto');
    setTimeout(function () { inp.focus({ preventScroll: true }); }, 60);
  }
  function chiudi() {
    box.classList.remove('is-aperto');
    document.documentElement.classList.remove('rr-bloccato');
    setTimeout(function () { if (!box.classList.contains('is-aperto')) box.hidden = true; }, 300);
    if (prima && prima.focus) prima.focus({ preventScroll: true });
  }
  window.rfRicercaApri = apri;

  function mostra(html) {
    pieno.innerHTML = html;
    pieno.hidden = false;
    if (vuoto) vuoto.hidden = true;
    corpo.scrollTop = 0;
  }
  function cerca() {
    var q = inp.value.trim();
    svuota.hidden = !q;
    clearTimeout(timer);
    if (!q) {
      if (ctrl) ctrl.abort();
      pieno.hidden = true;
      pieno.innerHTML = '';
      if (vuoto) vuoto.hidden = false;
      box.classList.remove('is-carica');
      ultimo = '';
      return;
    }
    timer = setTimeout(function () {
      if (q === ultimo) return;
      ultimo = q;
      if (cache[q]) { mostra(cache[q]); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      box.classList.add('is-carica');
      /* niente preview_theme_id qui: con i parametri resources Shopify risponde 422; l'anteprima resta dal cookie */
      var u = URL_SUG + '?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product,collection&resources%5Blimit%5D=8&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last&section_id=rf-ricerca';
      fetch(u, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var ris = d.querySelector('[data-rr-ris]');
        box.classList.remove('is-carica');
        if (!ris || inp.value.trim() !== q) return;
        cache[q] = ris.innerHTML;
        mostra(ris.innerHTML);
      }).catch(function () { box.classList.remove('is-carica'); });
    }, 220);
  }

  inp.addEventListener('input', cerca);
  svuota.addEventListener('click', function () { inp.value = ''; cerca(); inp.focus(); });
  box.querySelectorAll('[data-rr-chiudi]').forEach(function (b) { b.addEventListener('click', chiudi); });
  box.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-rr-q]');
    if (chip) { inp.value = chip.getAttribute('data-rr-q'); cerca(); inp.focus(); return; }
    if (e.target.closest('[data-rr-equivalente]')) { modoEquivalente(true); inp.value = ''; cerca(); inp.focus(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && box.classList.contains('is-aperto')) chiudi();
  });

  /* apre la nostra ricerca al posto di quella del tema: icona, campo in testata, Trova l'equivalente */
  ['pointerdown', 'click'].forEach(function (tipo) {
    window.addEventListener(tipo, function (e) {
      var t = e.target.closest && e.target.closest(APRI);
      if (!t || box.contains(t)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (tipo === 'click') apri({ equivalente: !!t.closest('.rf-trova') });
    }, true);
  });
})();
